const Footer = () => {
  return (
    <footer/>
  );
};

export default Footer;
